import React, { useState } from 'react';
import { DatePicker, Form, Input, Select, Skeleton } from "antd";
import { Text } from "react-font";
import { MDBAlert } from "mdbreact";
import { Button, Dialog } from "evergreen-ui";
import { useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import { getStorage } from "firebase/storage";
import { getDatabase, ref } from "firebase/database";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";


const { TextArea } = Input;
var storage = getStorage(Firebase);
var db = getDatabase(Firebase);
const moment = require("moment");
const ViewTask = (props) => {
    const [showLoading, setShowLoading] = useState(false);
    const [taskFile, setTaskFile] = useState(null);
    const [taskImage, setTaskImage] = useState(null);
    const [task, setTask] = useState(props.task);
    const [color, setColor] = useState("info");
    const [showAlert, setShowAlert] = useState(false);
    const [message, setMessage] = useState("");
    const [userArray, usersLoading] = useListVals(ref(db, "talmidsdb/users"));
    const [dueDate, setDueDate] = useState(null);
    const isLookupLoading = usersLoading;

    const handleFileUpload = (e) => {
        setTaskFile(e.target.files[0]);
    }

    const handleImage = (e) => {
        setTaskImage(e.target.files[0]);
    }

    function onChange(value, dateString) {
        setDueDate(dateString);
    }

    if (isLookupLoading) {
        return <Skeleton active paragraph={{ rows: 10 }} />;
    }

    return (
        <>
            <Form layout={"vertical"}
                initialValues={{
                    task: task.task,
                    status: task.taskStatus,
                    description: task.description,
                    dueDate: moment(task.dueDate, "YYYY-MM-DD"),
                    taskLink: task.taskLink,
                    assigned: task.assigned,
                    keywords: task.taskImageKeywords,
                    repeat: task.repeat,
                    repeatEvery: task.repeatEvery,
                    createdBy: task.createdBy
                }}
            >
                <Form.Item label="task" name="task">
                    <Input placeholder="task" disabled id="task" />
                </Form.Item>
                <Form.Item label="Task Status" name="status">
                    <Select placeholder="Select task status"
                        showSearch
                        disabled
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {["Pending", "Done"].map((item, index) => (
                            <Select.Option key={index} value={item}>{item}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="Description" name="description">
                    <TextArea disabled placeholder="description" id={"desc"} />
                </Form.Item>
                <Form.Item label="Task Image">
                    <Input type="file"
                        style={{ width: "100%" }}
                        accept="image/*"
                        disabled
                        onChange={handleImage}
                        placeholder="task image" id="task-image" />
                    <p className=" overflow-hidden">{task && task.urls[1]}</p>
                </Form.Item>
                <Form.Item label="Task Link" name="taskLink">
                    <Input type="text" disabled placeholder="task link" id="link" />
                </Form.Item>
                <Form.Item label="Task Image Keywords" name="keywords">
                    <Input type="text" disabled placeholder="task image keywords" id="keywords" />
                </Form.Item>
                <Form.Item label="Due Date" name="dueDate">
                    <DatePicker disabled onChange={onChange} value={!dueDate ? undefined : moment(dueDate, "YYYY-MM-DD")} style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item label="Created By" name="createdBy">
                    <Select placeholder="Select created by user"
                        showSearch
                        disabled
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {userArray.map((item, index) => (
                            <Select.Option value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item label="Assigned" name="assigned">
                    <Select placeholder="Select user assigned"
                        showSearch
                        disabled
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {userArray.map((item, index) => (
                            <Select.Option value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="Repeat" name="repeat">
                    <Select placeholder="Select task repeat"
                        showSearch
                        disabled
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {["Yes", "No"].map((item, index) => (
                            <Select.Option key={index} value={item}>{item}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="Repeat Every"
                    name="repeatEvery">
                    <Select placeholder="Select task repeat frequency"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {["Daily", "Weekly", "Monthly", "Yearly"].map((item, index) => (
                            <Select.Option key={index} value={item}>{item}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="File">
                    <Input type="file"
                        style={{ width: "100%" }}
                        accept="image/*"
                        disabled
                        onChange={handleFileUpload}
                        placeholder="task file" id="task-file" />
                    <p className=" overflow-hidden">{task && task.urls[0]}</p>
                </Form.Item>
                {showAlert ?
                    <>
                        <MDBAlert color={color} className="my-3 " >
                            {message}
                        </MDBAlert>
                    </>
                    : null}

                <Button appearance="primary" htmlType="submit" loading={showLoading}>
                    Edit
                </Button>
            </Form>

        </>
    )
}

export default ViewTask;
